import { BalanceType } from './types'

export const BalanceTypeTitles: Record<BalanceType, string> = {
  [BalanceType.User]: 'Пользовательский',
  [BalanceType.Deposit]: 'Депозитный',
  [BalanceType.Insurance]: 'Страховой',
}
